module.exports = __webpack_public_path__ + "img/check_balance_webshop_circle.8d52d9a.svg";